'use strict';

var _ = require('lodash');
var StrategyFactory = function StrategyFactory() {
  function Strategy(params) {
    this.name = params.name;
    this.description = params.description;
    this.createdBy = params.createdBy;
    this.lastUpdatedAt = params.lastUpdatedAt;
    this.technicalId = params.technicalId;
    this.eventTimeStamp = params.eventTimeStamp;
    if (_.isString(params.flowType)) {
      params.flowType = formatFlowTypeValue(params.flowType);
    }
    _.assignWith(this, params, paramsAssigningCustomizer);
  }
  function paramsAssigningCustomizer(objValue, srcValue) {
    return !_.isUndefined(srcValue) ? srcValue : objValue;
  }
  function formatFlowTypeValue(flowTypeEnum) {
    return flowTypeEnum.search(/FlowType./) === -1 ? 'FlowType.' + flowTypeEnum : flowTypeEnum;
  }
  return Strategy;
};
StrategyFactory.$inject = [];
module.exports = StrategyFactory;